// const prevUrl = "wms/receiptDemand"
export const id = {
    id: "WAREHOUSE_MANAGEMENT_RECEIPT_MONITOR",
    name: "收货监控",
    type: "menu"
    // method: 'POST',
    // apiName: 'getReceipt',
    // url: `${prevUrl}/list`
};

export const children = {
    // ADD_DATA: {
    //     id: 'WAREHOUSE_MANAGEMENT_RECEIPT_MONITOR_ADD_DATA',
    //     apiName: 'addReceipt',
    //     method: 'POST',
    //     name: '新建',
    //     type: 'view',
    //     url: `${prevUrl}/add`
    // }
};
